const disciplines = [
  {
    slug: 'discipline-artistic-swimming',
    title: 'Artistic Swimming',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-artistic-swimming-at-the-2024-olympics',
    OdfCode: 'SWA',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Artistic_Swimming.png')
  },
  {
    slug: 'discipline-diving',
    title: 'Diving',
    hrefLink: 'https://www.oneturf.news/olympics/2024-summer-olympic-games-history-about-diving',
    OdfCode: 'DIV',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Diving.png')
  },
  {
    slug: 'discipline-marathon-swimming',
    title: 'Marathon Swimming',
    hrefLink: 'https://www.oneturf.news/olympics/marathon-swimming-ahead-of-summer-olympics-2024',
    OdfCode: 'SWM',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Marathon_Swimming.png')
  },
  {
    slug: 'discipline-swimming',
    title: 'Swimming',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-swimming-ahead-of-2024-olympics',
    OdfCode: 'SWI',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Swimming.png')
  },
  {
    slug: 'discipline-water-polo',
    title: 'Water Polo',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-water-polo-ahead-of-2024-olympic-games',
    OdfCode: 'WAP',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Water_Polo.png')
  },
  {
    slug: 'discipline-archery',
    title: 'Archery',
    hrefLink: 'https://oneturf.news/olympics/paris-olympics-2024-know-all-about-archery-competition-8216',
    OdfCode: 'ARC',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Archery.png')
  },
  {
    slug: 'discipline-athletics',
    title: 'Athletics',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-athletics-at-the-paris-2024-olympics',
    OdfCode: 'ATH',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Athletics.png')
  },
  {
    slug: 'discipline-badminton',
    title: 'Badminton',
    hrefLink: 'https://oneturf.news/olympics/all-about-badminton-at-the-paris-2024-olympics',
    OdfCode: 'BDM',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Badminton.png')
  },
  {
    slug: 'discipline-basketball',
    title: 'Basketball',
    hrefLink: 'https://oneturf.news/olympics/paris-olympics-2024-know-all-basketball-competition',
    OdfCode: 'BKB',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Basketball.png')
  },
  {
    slug: 'discipline-boxing',
    title: 'Boxing',
    hrefLink: 'https://oneturf.news/olympics/all-about-boxing-at-the-paris-2024-olympics-7648',
    OdfCode: 'BOX',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Boxing.png')
  },
  {
    slug: 'discipline-breaking',
    title: 'Breaking',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-breaking-at-the-paris-2024-olympics',
    OdfCode: 'BRK',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Breaking.png')
  },
  {
    slug: 'discipline-slalom',
    title: 'Slalom',
    hrefLink: 'https://www.oneturf.news/olympics/summer-olympics-2024-history-about-slalom-8282',
    OdfCode: 'CSL',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Canoe_Slalom.png')
  },
  {
    slug: 'discipline-sprint',
    title: 'Sprint',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-sprint-ahead-of-the-summer-olympics-2024',
    OdfCode: 'CSP',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Canoe_Sprint.png')
  },
  {
    slug: 'discipline-road-cycling',
    title: 'Road Cycling',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-road-cycling-ahead-of-2024-olympics',
    OdfCode: 'CRC',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Cycling_Road.png')
  },
  {
    slug: 'discipline-track-cycling',
    title: 'Track Cycling',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-track-cycling-ahead-of-the-summer-olympics-2024',
    OdfCode: 'CTC',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Cycking_Track.png')
  },
  {
    slug: 'discipline-bmx',
    title: 'BMX',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-bmx-racing-ahead-of-the-2024-olympics',
    OdfCode: 'CBX',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Cycling_BMX_Racing.png')
  },
  {
    slug: 'discipline-mountain-biking',
    title: 'Mountain Biking',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-mountain-biking-at-the-paris-2024-olympics',
    OdfCode: 'MTB',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Cycling_BMX_Mountain_Bike.png')
  },
  {
    slug: 'discipline-dressage',
    title: 'Dressage',
    hrefLink: 'https://www.oneturf.news/olympics/history-about-dressage-ahead-of-paris-olympics-2024',
    OdfCode: 'EQU',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Dressage.png')
  },
  {
    slug: 'discipline-equestrian',
    title: 'Equestrian',
    hrefLink: 'https://www.oneturf.news/olympics/history-about-equestrian-ahead-of-the-2024-olympic-games',
    OdfCode: 'EQU',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Equestrian.png')
  },
  {
    slug: 'discipline-jumping',
    title: 'Jumping',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-jumping-ahead-of-the-2024-olympics',
    OdfCode: 'JMP',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Jumping.png')
  },
  {
    slug: 'discipline-fencing',
    title: 'Fencing',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-fencing-at-the-2024-olympic-games',
    OdfCode: 'FEN',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Fencing.png')
  },
  {
    slug: 'discipline-field-hockey',
    title: 'Field Hockey',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-field-hockey-at-the-paris-2024-olympics',
    OdfCode: 'FHK',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Hockey.png')
  },
  {
    slug: 'discipline-golf',
    title: 'Golf',
    hrefLink: 'https://oneturf.news/olympics/all-about-golf-ahead-of-the-2024-olympic-games-6932',
    OdfCode: 'GOL',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Golf.png')
  },
  {
    slug: 'discipline-judo',
    title: 'Judo',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-judo-ahead-of-the-2024-summer-olympic-games',
    OdfCode: 'JUD',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Judo.png')
  },
  // {
  //   slug: 'discipline-karate',
  //   title: 'Karate',
  //   hrefLink: 'https://www.oneturf.news/olympics/all-about-karate-ahead-of-2024-olympics',
  //   OdfCode: 'KAR',
  //   SortOrder: 999,
  //   image: require('assets/images/olympics-sports-icons/Taekwondo.png')
  // },
  {
    slug: 'discipline-modern-pentathlon',
    title: 'Modern Pentathlon',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-modern-pentathlon-ahead-of-the-2024-olympic-games',
    OdfCode: 'MPF',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Modern_Pentathlon.png')
  },
  {
    slug: 'discipline-rowing',
    title: 'Rowing',
    hrefLink: 'https://www.oneturf.news/olympics/rules-of-rowing-ahead-of-the-2024-olympics',
    OdfCode: 'ROW',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Rowing.png')
  },
  {
    slug: 'discipline-sailing',
    title: 'Sailing',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-sailing-ahead-of-the-2024-olympic-games',
    OdfCode: 'SAI',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Sailing.png')
  },
  {
    slug: 'discipline-taekwondo',
    title: 'Taekwondo',
    hrefLink: 'https://oneturf.news/olympics/know-all-about-taekwondo-ahead-of-the-2024-olympic-games',
    OdfCode: 'TAE',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Taekwondo.png')
  },
  {
    slug: 'discipline-table-tennis',
    title: 'Table Tennis',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-table-tennis-ahead-of-2024-olympic-games',
    OdfCode: 'TTA',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Table_Tennis.png')
  },
  {
    slug: 'discipline-tennis',
    title: 'Tennis',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-tennis-ahead-of-2024-olympic-games',
    OdfCode: 'TEN',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Tennis.png')
  },
  {
    slug: 'discipline-triathlon',
    title: 'Triathlon',
    hrefLink: 'https://oneturf.news/olympics/know-all-about-triathlon-ahead-of-the-2024-olympic-games',
    OdfCode: 'TRI',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Triathlon.png')
  },
  {
    slug: 'discipline-volleyball',
    title: 'Volleyball',
    hrefLink: 'https://www.oneturf.news/olympics/rules-of-volleyball-ahead-of-the-summer-olympics-2024',
    OdfCode: 'VOL',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Volleyball.png')
  },
  {
    slug: 'discipline-weightlifting',
    title: 'Weightlifting',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-weightlifting-ahead-of-the-2024-olympic-games',
    OdfCode: 'WLT',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Weightlifting.png')
  },
  {
    slug: 'discipline-wrestling',
    title: 'Wrestling',
    hrefLink: 'https://www.oneturf.news/olympics/all-about-wrestling-ahead-of-the-olympic-games-2024',
    OdfCode: 'WRE',
    SortOrder: 999,
    image: require('assets/images/olympics-sports-icons/Wrestling.png')
  }
]
export default disciplines
